import { render, staticRenderFns } from "./BlockContentProp.vue?vue&type=template&id=1bb08eb8&"
import script from "./BlockContentProp.vue?vue&type=script&lang=js&"
export * from "./BlockContentProp.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports